const MODELS = {
  booking: 'models/booking',
  bookingPackagePricing: 'models/bookingPackagePricing',
  customer: 'models/customer',
  mpUserDetails: 'models/mpUserDetails',
  project: 'models/project',
  projectUnit: 'models/projectUnit',
  projectUnitLayout: 'models/projectUnitLayout',
  user: 'models/user',
  businessUnit: 'models/businessUnit',
  tokenSetting: 'models/tokenSetting',
};

export const TRANSLATION_FILES = {
  screens: 'screens',
  constants: 'constants',
  translation: 'translation',
  models: MODELS,
};

export const namespaces = [
  TRANSLATION_FILES.screens,
  TRANSLATION_FILES.constants,
  TRANSLATION_FILES.translation,
];



// WEBPACK FOOTER //
// ./src/constants/translation.js